module.exports = __webpack_public_path__ + "img/books.00c55981.png";